<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="d-flex justify-space-between align-center">
            <span>Bildirim Ayarları</span>
            <div>
              <v-btn
                color="info"
                @click="autoSetup"
                :loading="autoSetupLoading"
                :disabled="autoSetupLoading || loading"
                class="mr-2"
              >
                <v-icon left>mdi-auto-fix</v-icon>
                Otomatik Ayarla
              </v-btn>
              <v-btn
                color="success"
                @click="saveAll"
                :loading="savingAll"
                :disabled="savingAll"
              >
                <v-icon left>mdi-content-save-all</v-icon>
                Tüm Ayarları Kaydet
              </v-btn>
            </div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-alert
              v-if="alert.show"
              :type="alert.type"
              dismissible
              @input="alert.show = false"
            >
              {{ alert.message }}
            </v-alert>



            <v-data-table
              :headers="headers"
              :items="settings"
              :loading="loading"
              class="elevation-2 notification-table"
              hide-default-footer
              disable-pagination
              :items-per-page="-1"
            >
              <!-- Header tooltips -->
              <template v-slot:header.realtime>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Realtime Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Gerçek zamanlı veri mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.saveMessage>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Save Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Veri kaydetme mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.synced>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Synced Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Senkronize edilmiş mesajlar için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.history>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Geçmiş veri mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.historyMulti>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History-Multi Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Çoklu geçmiş veri mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.historySynced>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History-Synced Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Senkronize geçmiş mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.historyMultiSynced>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      History-Multi-Synced Mesajları (dk)
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Çoklu senkronize geçmiş mesajları için uyarı süresi</span>
                </v-tooltip>
              </template>

              <template v-slot:header.isActive>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      Durum
                      <v-icon small color="grey">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span>Bildirim aktif/pasif durumu</span>
                </v-tooltip>
              </template>

              <template v-slot:item.dataloggerName="{ item }">
                <strong>{{ item.Datalogger.name }}</strong>
              </template>

              <template v-slot:item.realtime="{ item }">
                <v-text-field
                  v-model.number="item.realtime"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-realtime`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.saveMessage="{ item }">
                <v-text-field
                  v-model.number="item.saveMessage"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-saveMessage`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.synced="{ item }">
                <v-text-field
                  v-model.number="item.synced"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-synced`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.history="{ item }">
                <v-text-field
                  v-model.number="item.history"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-history`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.historyMulti="{ item }">
                <v-text-field
                  v-model.number="item.historyMulti"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-historyMulti`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.historySynced="{ item }">
                <v-text-field
                  v-model.number="item.historySynced"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-historySynced`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.historyMultiSynced="{ item }">
                <v-text-field
                  v-model.number="item.historyMultiSynced"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  outlined
                  style="min-width: 120px;"
                  :class="{ 'auto-setup-field': autoSetupFields.has(`${item.dataloggerId}-historyMultiSynced`) }"
                ></v-text-field>
              </template>

              <template v-slot:item.isActive="{ item }">
                <div class="d-flex align-center justify-center">
                  <v-switch
                    v-model="item.isActive"
                    color="success"
                    hide-details
                    dense
                    @change="toggleNotification(item)"
                    :loading="item.toggling"
                    :disabled="item.toggling"
                    class="mr-2"
                  ></v-switch>
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  color="primary"
                  small
                  @click="saveRow(item)"
                  :loading="item.saving"
                  :disabled="item.saving"
                >
                  <v-icon small left>mdi-content-save</v-icon>
                  Kaydet
                </v-btn>
              </template>
            </v-data-table>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// axios artık $api olarak global olarak mevcut

export default {
  name: 'Notifications',
  data() {
    return {
      settings: [],
      loading: false,
      savingAll: false,
      autoSetupLoading: false,
      autoSetupFields: new Set(),
      alert: {
        show: false,
        type: 'success',
        message: ''
      },
      headers: [
        { text: 'Datalogger', value: 'dataloggerName', sortable: false, width: '200px', align: 'start' },
        {
          text: 'Realtime Mesajları (dk)',
          value: 'realtime',
          sortable: false,
          width: '160px',
          align: 'center',
          tooltip: 'Gerçek zamanlı veri mesajları için uyarı süresi'
        },
        {
          text: 'Save Mesajları (dk)',
          value: 'saveMessage',
          sortable: false,
          width: '160px',
          align: 'center',
          tooltip: 'Veri kaydetme mesajları için uyarı süresi'
        },
        {
          text: 'Synced Mesajları (dk)',
          value: 'synced',
          sortable: false,
          width: '160px',
          align: 'center',
          tooltip: 'Senkronize edilmiş mesajlar için uyarı süresi'
        },
        {
          text: 'History Mesajları (dk)',
          value: 'history',
          sortable: false,
          width: '160px',
          align: 'center',
          tooltip: 'Geçmiş veri mesajları için uyarı süresi'
        },
        {
          text: 'History-Multi Mesajları (dk)',
          value: 'historyMulti',
          sortable: false,
          width: '180px',
          align: 'center',
          tooltip: 'Çoklu geçmiş veri mesajları için uyarı süresi'
        },
        {
          text: 'History-Synced Mesajları (dk)',
          value: 'historySynced',
          sortable: false,
          width: '190px',
          align: 'center',
          tooltip: 'Senkronize geçmiş mesajları için uyarı süresi'
        },
        {
          text: 'History-Multi-Synced Mesajları (dk)',
          value: 'historyMultiSynced',
          sortable: false,
          width: '220px',
          align: 'center',
          tooltip: 'Çoklu senkronize geçmiş mesajları için uyarı süresi'
        },
        {
          text: 'Durum',
          value: 'isActive',
          sortable: false,
          width: '120px',
          align: 'center',
          tooltip: 'Bildirim aktif/pasif durumu'
        },
        { text: 'İşlemler', value: 'actions', sortable: false, width: '140px', align: 'center' }
      ]
    }
  },
  async created() {
    await this.fetchSettings()
  },
  methods: {
    async fetchSettings() {
      this.loading = true
      try {
        const response = await this.$api.get('/api/notifications')
        this.settings = response.data.map(setting => ({
          id: setting.id,
          dataloggerId: setting.datalogger_id,
          realtime: setting.realtime || 0,
          saveMessage: setting.save_message || 0,
          synced: setting.synced || 0,
          history: setting.history || 0,
          historyMulti: setting.history_multi || 0,
          historySynced: setting.history_synced || 0,
          historyMultiSynced: setting.history_multi_synced || 0,
          isActive: setting.is_active !== undefined ? setting.is_active : true,
          createdAt: setting.createdAt,
          updatedAt: setting.updatedAt,
          Datalogger: setting.Datalogger,
          saving: false,
          toggling: false
        })).filter(setting => setting.dataloggerId) // undefined dataloggerId'leri filtrele
      } catch (error) {
        console.error('Error fetching notification settings:', error)
        this.showAlert('error', 'Failed to load notification settings')
      } finally {
        this.loading = false
      }
    },

    async saveRow(item) {
      item.saving = true
      try {
        const updateData = {
          realtime: item.realtime || 0,
          save_message: item.saveMessage || 0,
          synced: item.synced || 0,
          history: item.history || 0,
          history_multi: item.historyMulti || 0,
          history_synced: item.historySynced || 0,
          history_multi_synced: item.historyMultiSynced || 0,
          is_active: item.isActive
        }

        await this.$api.put(`/api/notifications/${item.dataloggerId}`, updateData)
        this.showAlert('success', `Settings saved for ${item.Datalogger.name}`)
      } catch (error) {
        console.error('Error saving notification setting:', error)
        this.showAlert('error', `Failed to save settings for ${item.Datalogger.name}`)
      } finally {
        item.saving = false
      }
    },

    async saveAll() {
      this.savingAll = true
      try {
        const settingsData = this.settings.map(setting => ({
          datalogger_id: setting.dataloggerId,
          realtime: setting.realtime || 0,
          save_message: setting.saveMessage || 0,
          synced: setting.synced || 0,
          history: setting.history || 0,
          history_multi: setting.historyMulti || 0,
          history_synced: setting.historySynced || 0,
          history_multi_synced: setting.historyMultiSynced || 0,
          is_active: setting.isActive
        }))

        await this.$api.put('/api/notifications', settingsData)
        this.showAlert('success', 'All notification settings saved successfully')
      } catch (error) {
        console.error('Error saving all notification settings:', error)
        this.showAlert('error', 'Failed to save notification settings')
      } finally {
        this.savingAll = false
      }
    },

    async toggleNotification(item) {
      item.toggling = true
      try {
        const updateData = {
          realtime: item.realtime || 0,
          save_message: item.saveMessage || 0,
          synced: item.synced || 0,
          history: item.history || 0,
          history_multi: item.historyMulti || 0,
          history_synced: item.historySynced || 0,
          history_multi_synced: item.historyMultiSynced || 0,
          is_active: item.isActive
        }

        await this.$api.put(`/api/notifications/${item.dataloggerId}`, updateData)

        const statusText = item.isActive ? 'aktif edildi' : 'deaktif edildi'
        this.showAlert('success', `${item.Datalogger.name} için bildirimler ${statusText}`)
      } catch (error) {
        console.error('Error toggling notification:', error)
        // Revert the toggle on error
        item.isActive = !item.isActive
        this.showAlert('error', `${item.Datalogger.name} için bildirim durumu değiştirilemedi`)
      } finally {
        item.toggling = false
      }
    },

    async autoSetup() {
      this.autoSetupLoading = true
      this.autoSetupFields.clear()

      try {
        // /status endpoint'inden veri çek
        const response = await this.$api.get('/api/status')
        const statusData = response.data

        let updatedCount = 0

        // Her datalogger için ayarları güncelle
        this.settings.forEach(setting => {
          const dataloggerStatus = statusData.find(d => d.id === setting.dataloggerId)
          if (!dataloggerStatus) return

          // Mesaj türlerini kontrol et ve ayarla
          this.processMessageType(setting, dataloggerStatus, 'realtime', 'realtime', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'save', 'saveMessage', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'synced', 'synced', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'history', 'history', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'history-multi', 'historyMulti', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'history-synced', 'historySynced', updatedCount)
          this.processMessageType(setting, dataloggerStatus, 'history-multi-synced', 'historyMultiSynced', updatedCount)
        })

        this.showAlert('success', `Otomatik ayarlama tamamlandı. ${this.autoSetupFields.size} alan güncellendi.`)

      } catch (error) {
        console.error('Error during auto setup:', error)
        this.showAlert('error', 'Otomatik ayarlama sırasında hata oluştu')
      } finally {
        this.autoSetupLoading = false
      }
    },

    processMessageType(setting, dataloggerStatus, messageType, settingField, updatedCount) {
      let lastSeen = null

      // Groups'tan mesaj ara
      if (['realtime', 'save', 'synced'].includes(messageType)) {
        for (const group of dataloggerStatus.groups) {
          if (group.messages && group.messages[messageType] && group.messages[messageType].lastSeen) {
            const messageTime = new Date(group.messages[messageType].lastSeen)
            if (!lastSeen || messageTime > lastSeen) {
              lastSeen = messageTime
            }
          }
        }
      }

      // History'den mesaj ara
      if (['history', 'history-multi', 'history-synced', 'history-multi-synced'].includes(messageType)) {
        for (const history of dataloggerStatus.history) {
          if (history.messages && history.messages[messageType] && history.messages[messageType].lastSeen) {
            const messageTime = new Date(history.messages[messageType].lastSeen)
            if (!lastSeen || messageTime > lastSeen) {
              lastSeen = messageTime
            }
          }
        }
      }

      let newValue = 0

      if (lastSeen) {
        const now = new Date()
        const diffMinutes = Math.floor((now - lastSeen) / (1000 * 60))

        if (diffMinutes <= 10) {
          newValue = 15
        } else if (diffMinutes <= 30) {
          newValue = 45
        } else if (diffMinutes <= 60) {
          newValue = 90
        } else {
          newValue = 0
        }
      }

      // Sadece değer değiştiyse vurgula
      const oldValue = setting[settingField]
      if (oldValue !== newValue) {
        setting[settingField] = newValue
        this.autoSetupFields.add(`${setting.dataloggerId}-${settingField}`)
      }
    },

    showAlert(type, message) {
      this.alert = {
        show: true,
        type: type,
        message: message
      }
    }
  }
}
</script>

<style scoped>
.v-data-table :deep(.v-data-table__wrapper) {
  overflow-x: auto;
}

/* Light Theme Styles */
.v-theme--light .v-data-table :deep(th) {
  white-space: nowrap;
  font-weight: 600 !important;
  background-color: #f5f7fa;
  color: #2C5F7C;
  border-bottom: 2px solid #A8D5BA;
}

.v-theme--light .v-data-table :deep(tbody tr:hover) {
  background-color: rgba(168, 213, 186, 0.1) !important;
}



/* Dark Theme Styles */
.v-theme--dark .v-data-table :deep(th) {
  white-space: nowrap;
  font-weight: 600 !important;
  background-color: #2D2D2D;
  color: #A8D5BA;
  border-bottom: 2px solid #4A8DB8;
}

.v-theme--dark .v-data-table :deep(tbody tr) {
  background-color: #1A1A1A;
}

.v-theme--dark .v-data-table :deep(tbody tr:hover) {
  background-color: rgba(168, 213, 186, 0.15) !important;
}

.v-theme--dark .v-card {
  background-color: #2D2D2D !important;
}



.v-theme--dark .v-text-field--outlined :deep(.v-field__outline) {
  --v-field-border-color: #4A8DB8;
}

.v-theme--dark .v-text-field--outlined:hover :deep(.v-field__outline) {
  --v-field-border-color: #A8D5BA;
}

.v-theme--dark .v-text-field--outlined.v-field--focused :deep(.v-field__outline) {
  --v-field-border-color: #A8D5BA;
}

.v-theme--dark .v-text-field :deep(input) {
  color: #A8D5BA;
}

/* White Background Card Styles */
.white-bg-card {
  background-color: white !important;
}

.white-bg-title {
  background: white !important;
  color: #2C5F7C !important;
}

.v-theme--dark .white-bg-card {
  background-color: white !important;
}

.v-theme--dark .white-bg-title {
  background: white !important;
  color: #2C5F7C !important;
}

/* Common Styles */
.v-data-table :deep(td) {
  padding: 12px 8px !important;
}

.v-text-field :deep(.v-input__control) {
  min-height: 40px;
}

.v-text-field :deep(input) {
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.v-text-field.v-text-field--outlined :deep(.v-input__control .v-input__slot) {
  min-height: 40px;
}

.v-card-title .v-icon {
  color: white !important;
}

.v-data-table :deep(th span) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.v-alert ul {
  margin-left: 20px;
}

.v-alert li {
  margin-bottom: 2px;
}

/* Button Styles for Dark Theme */
.v-theme--dark .v-btn--variant-elevated {
  background-color: #4A8DB8;
  color: white;
}

.v-theme--dark .v-btn--variant-elevated:hover {
  background-color: #A8D5BA;
  color: #1A1A1A;
}

.v-theme--dark .v-btn.v-btn--variant-elevated.v-btn--color-success {
  background-color: #58D68D;
  color: #1A1A1A;
}

.v-theme--dark .v-btn.v-btn--variant-elevated.v-btn--color-success:hover {
  background-color: #A8D5BA;
}

/* Tooltip Styles for Dark Theme */
.v-theme--dark .v-tooltip .v-overlay__content {
  background-color: #2D2D2D;
  color: #A8D5BA;
  border: 1px solid #4A8DB8;
}

/* Data Table Header Icons */
.v-theme--dark .v-data-table :deep(th .v-icon) {
  color: #A8D5BA !important;
}

.v-theme--light .v-data-table :deep(th .v-icon) {
  color: #2C5F7C !important;
}

/* Switch Styles */
.v-theme--dark .v-switch :deep(.v-selection-control__wrapper) {
  color: #A8D5BA;
}

.v-theme--dark .v-switch :deep(.v-switch__track) {
  background-color: #4A4A4A;
  transition: background-color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-active :deep(.v-switch__track) {
  background-color: #58D68D;
}

.v-theme--dark .v-switch :deep(.v-switch__thumb) {
  background-color: #A8D5BA;
  transition: background-color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-active :deep(.v-switch__thumb) {
  background-color: white;
}

.v-theme--dark .v-switch.v-input--is-disabled :deep(.v-switch__track) {
  background-color: #333333 !important;
  opacity: 0.6;
}

.v-theme--dark .v-switch.v-input--is-disabled :deep(.v-switch__thumb) {
  background-color: #666666 !important;
}

.v-theme--dark .v-label {
  color: #A8D5BA !important;
  font-weight: 500;
  transition: color 0.3s ease;
}

.v-theme--dark .v-switch.v-input--is-disabled .v-label {
  color: #666666 !important;
}

.v-theme--light .v-switch :deep(.v-switch__track) {
  transition: background-color 0.3s ease;
}

.v-theme--light .v-switch.v-input--is-active :deep(.v-switch__track) {
  background-color: #58D68D;
}

.v-theme--light .v-switch.v-input--is-active :deep(.v-switch__thumb) {
  background-color: white;
}

.v-theme--light .v-switch.v-input--is-disabled :deep(.v-switch__track) {
  opacity: 0.6;
}

.v-theme--light .v-switch.v-input--is-disabled :deep(.v-switch__thumb) {
  opacity: 0.6;
}

.v-theme--light .v-label {
  font-weight: 500;
  transition: color 0.3s ease;
}

.v-theme--light .v-switch.v-input--is-disabled .v-label {
  color: #999999 !important;
}

/* Switch Loading Animation */
.v-switch.v-input--is-loading :deep(.v-switch__thumb) {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

/* Alert Styles for Dark Theme */
.v-theme--dark .v-alert {
  background-color: #2D2D2D;
  border: 1px solid #4A8DB8;
}

.v-theme--dark .v-alert.v-alert--type-success {
  background-color: rgba(88, 214, 141, 0.1);
  border-color: #58D68D;
  color: #A8D5BA;
}

.v-theme--dark .v-alert.v-alert--type-error {
  background-color: rgba(231, 76, 60, 0.1);
  border-color: #E74C3C;
  color: #ff9999;
}

/* Card Styles */
.notification-card {
  border-radius: 12px;
  overflow: hidden;
}

.notification-header {
  padding: 20px 24px;
  font-weight: 600;
}

.notification-table {
  border-radius: 8px;
  overflow: hidden;
}

/* Loading Overlay for Dark Theme */
.v-theme--dark .v-data-table :deep(.v-data-table__loading) {
  background-color: rgba(26, 26, 26, 0.8);
}

.v-theme--dark .v-data-table :deep(.v-data-table__loading .v-progress-circular) {
  color: #A8D5BA;
}

/* Scrollbar Styles for Dark Theme */
.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar {
  height: 8px;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-track {
  background: #2D2D2D;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb {
  background: #4A8DB8;
  border-radius: 4px;
}

.v-theme--dark .v-data-table :deep(.v-data-table__wrapper)::-webkit-scrollbar-thumb:hover {
  background: #A8D5BA;
}

/* Auto Setup Field Highlighting */
.auto-setup-field :deep(.v-field__outline) {
  --v-field-border-color: #4CAF50 !important;
  --v-field-border-width: 2px !important;
}

.v-theme--dark .auto-setup-field :deep(.v-field__outline) {
  --v-field-border-color: #66BB6A !important;
  --v-field-border-width: 2px !important;
}

.auto-setup-field :deep(.v-field__input) {
  background-color: rgba(76, 175, 80, 0.05) !important;
}

.v-theme--dark .auto-setup-field :deep(.v-field__input) {
  background-color: rgba(102, 187, 106, 0.1) !important;
}

/* Status Label Styles */
.status-label {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  min-width: 50px;
  text-align: center;
}

.v-theme--light .status-active {
  background-color: rgba(76, 175, 80, 0.1);
  color: #2E7D32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.v-theme--light .status-inactive {
  background-color: rgba(158, 158, 158, 0.1);
  color: #616161;
  border: 1px solid rgba(158, 158, 158, 0.3);
}

.v-theme--light .status-disabled {
  background-color: rgba(189, 189, 189, 0.1);
  color: #9E9E9E;
  border: 1px solid rgba(189, 189, 189, 0.3);
  opacity: 0.6;
}

.v-theme--dark .status-active {
  background-color: rgba(102, 187, 106, 0.15);
  color: #66BB6A;
  border: 1px solid rgba(102, 187, 106, 0.4);
}

.v-theme--dark .status-inactive {
  background-color: rgba(158, 158, 158, 0.15);
  color: #BDBDBD;
  border: 1px solid rgba(158, 158, 158, 0.4);
}

.v-theme--dark .status-disabled {
  background-color: rgba(97, 97, 97, 0.15);
  color: #757575;
  border: 1px solid rgba(97, 97, 97, 0.4);
  opacity: 0.6;
}
</style>
